import { tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    description: tsValidateString(undefined, false),
};
const Validator_GeneratedProps = {};
export const DBDef_FlowSheet = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'flow-sheet',
    entityName: 'Quai Note',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'flow-sheet'
    },
    backend: {
        name: 'flow-sheet'
    }
};
//# sourceMappingURL=db-def.js.map